import { Controller } from "stimulus";
import $ from "jquery";
import { verifyAddressValues } from "../../form-utilities/verifyAddressFields";

export default class extends Controller {
  static targets = [
    "addressFull",
    "radiusInput",
    "saveButton",
    "columnAddress",
    "latitude",
    "longitude",
  ];

  timers = [];
  connect() {
    const defaultConfig = this.defaultSelect2Config();
    const states = this.$state();
    const cities = this.$city();

    this.initialControlForEditingMode();
    this.enableButtonsIfFilledFields();

    this.initSelect2WithAutoClose(states, defaultConfig);
    this.initSelect2WithAutoClose(cities, defaultConfig);

    states.on("select2:select", function () {
      this.dispatchEvent(new Event("change", { bubbles: true }));
    });
    cities.on("select2:select", function () {
      this.dispatchEvent(new Event("change", { bubbles: true }));
    });

    states.on("select2:unselect change.select2", () => this.resetStateAndCity());
    cities.on("select2:unselect", () => this.resetCity());

    document.getElementById("dynamic_state").addEventListener("change", () => this.validateFormState());
    document.getElementById("dynamic_city").addEventListener("change", () => this.validateFormState());
  }

  defaultSelect2Config() {
    return { placeholder: "Selecionar...", language: "pt-BR", allowClear: true, tags: false };
  }

  $state() { return $("#dynamic_state"); }
  $city() { return $("#dynamic_city"); }

  initSelect2WithAutoClose($el, config) {
    $el.select2(config).on("select2:unselecting select2:select", function () {
      const self = $(this);
      setTimeout(() => self.select2("close"), 0);
    });
  }

  resetStateAndCity() {
    const cities = this.$city();
    cities.val("");
    cities.children().remove();
    this.commonResetActions();
  }

  resetCity() {
    this.commonResetActions();
  }

  commonResetActions() {
    this.disableAllInputs();
    this.clearAllInputs();
    this.disableSaveButton();
    this.removeAddressError();
    this.clearCoordinates();
  }

  validateAddressState() {
    const street = $("#dynamic_street").val();
    const number = $("#dynamic_number").val();
    const district = $("#dynamic_district").val();

    return street && street.trim() !== '' &&
           number && number.trim() !== '' &&
           district && district.trim() !== '';
  }

  validateFormState() {
    const state = document.getElementById('dynamic_state').value;
    const city = document.getElementById('dynamic_city').value;

    if (!state || !city) {
      this.disableSaveButton();
      this.disableAllInputs();
      this.clearAllInputs();
      this.clearCoordinates();
      this.removeAddressError();
      return;
    }

    const allAddressfilled = this.validateAddressState();

    if (!allAddressfilled) {
      this.disableSaveButton();
      this.removeAddressError();
      return;
    }

    const hasValidCoords = this.hasValidCoordinates();
    if (hasValidCoords) {
      this.saveButtonTarget.disabled = false;
      this.removeAddressError();
    }
  }

  clearCoordinates() {
    this.latitudeTarget.value = '';
    this.longitudeTarget.value = '';
  }

  initialControlForEditingMode() {
    if (!verifyAddressValues(this.addressFullTargets)) {
      this.saveButtonTarget.disabled = true;
      return;
    }

    const hasValidCoords = this.hasValidCoordinates();
    this.saveButtonTarget.disabled = !hasValidCoords;
    this.enableInputs();

    if (!hasValidCoords) {
      this.showAddressError('Endereço inválido. Por favor, corrija o endereço.');
    } else {
      this.removeAddressError();
    }

    setTimeout(() => {
      this.dragMarker();
      setTimeout(() => {
        if (!window.circle) {
          this.drawCircle();
          window.circle.setVisible(true);
          window.map.setZoom(15);
        }
      }, 100);
    }, 150);
  }

  enableButtonsIfFilledFields() {
    this.addressFullTargets.forEach((field) => {
      field.addEventListener("change", () => {
        this.validateFormState();
      });
    });

    this.latitudeTarget.addEventListener("change", () => this.validateFormState());
    this.longitudeTarget.addEventListener("change", () => this.validateFormState());
  }

  hasValidCoordinates() {
    return this.latitudeTarget.value &&
           this.longitudeTarget.value &&
           this.latitudeTarget.value !== 'null' &&
           this.longitudeTarget.value !== 'null' &&
           parseFloat(this.latitudeTarget.value) !== 0 &&
           parseFloat(this.longitudeTarget.value) !== 0;
  }

  selectState() {
    let cities = $("#dynamic_city");
    let chosenState = document.getElementById("dynamic_state").value;
    this.fillCitiesOptions(chosenState, cities);
  }

  selectCity() {
    this.enableInputs();
    this.dragMarker();
    window.marker.setDraggable(true);
    if (!window.circle) {
      this.drawCircle();
      window.circle.setVisible(true);
    } else {
      window.circle.setVisible(true);
    }

    if (this.validateAddressState()) this.validateFormState();
  }

  enableInputs() {
    this.addressFullTargets.forEach((element) => { element.disabled = false; });
    this.radiusInputTarget.disabled = false;
    this.showColumnAddress();
  }

  disableAllInputs() {
    this.addressFullTargets.forEach((element) => { element.disabled = true; });
    this.radiusInputTarget.disabled = true;
    this.hiddenColumnAddress();
  }

  clearAllInputs() {
    this.addressFullTargets.forEach((element) => { element.value = ""; });
    this.clearCoordinates();
  }

  clearButton() {
    const states = this.$state();
    const cities = this.$city();
    const defaultConfig = this.defaultSelect2Config();

    states.val("");
    cities.val("");
    states.select2(defaultConfig);
    cities.select2(defaultConfig);

    this.clearAllInputs();
    this.disableSaveButton();
    this.hiddenColumnAddress();
    if (window.marker) window.marker.setDraggable(false);
    if (window.circle) window.circle.setVisible(false);
    this.removeAddressError();
  }

  showColumnAddress() {
    this.columnAddressTarget.classList.remove("is-hidden");
  }

  hiddenColumnAddress() {
    this.columnAddressTarget.classList.add("is-hidden");
  }

  fillCitiesOptions(selected_state, cities_field) {
    Rails.ajax({
      url: `/state/${selected_state}/cities`,
      type: "get",
      data: "",
      success: function (data) {
        cities_field.children().remove();
        data.forEach((city) => {
          var new_option = new Option(city.name, city.id, false, false);
          cities_field.append(new_option);
        });
        cities_field.val("");
      },
      error: function (data) {},
    });
  }

  verify() {
    if (this.addressFullTargets[0].value && this.addressFullTargets[2].value) {
      this.debounce(() => this.setCoord(this.latitudeTarget, this.longitudeTarget), 600);
    } else {
      this.removeAddressError();
    }
  }

  debounce(func, wait) {
    while (this.timers.length) {
      clearTimeout(this.timers.pop());
    }
    this.timers.push(setTimeout(func, wait));
  }

  refreshMarker() {
    var position;
    if (this.latitudeTarget.value && this.longitudeTarget.value) {
      position = new google.maps.LatLng(
        this.latitudeTarget.value,
        this.longitudeTarget.value
      );
    } else {
      position = window.map.getCenter();
    }

    window.marker.setPosition(position);

    window.map.panTo(window.marker.getPosition());
  }

  dragMarker() {
    var onDrag = function () {
      var latlng = marker.getPosition();
      var newlat = Math.round(latlng.lat() * 1000000) / 1000000;
      var newlng = Math.round(latlng.lng() * 1000000) / 1000000;
      this.latitudeTarget.value = newlat;
      this.longitudeTarget.value = newlng;
      this.validateFormState();
    };
    var afterDrag = function () {
      window.map.panTo(marker.getPosition());
    };
    window.marker.addListener("drag", onDrag.bind(this));
    window.marker.addListener("dragend", afterDrag.bind(this));
  }

  drawCircle() {
    let circle = new google.maps.Circle({
      map: window.map,
      radius: parseInt(this.radiusInputTarget.value, 10),
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      visible: false,
    });

    circle.bindTo("center", window.marker, "position");
    window.circle = circle;
  }

  updateRadius() {
    window.circle.setRadius(parseInt(this.radiusInputTarget.value, 10));
  }

  setCoord(lat, lon) {
    const addressString = `${$("#dynamic_street").val()},${$(
      "#dynamic_number"
    ).val()},${$("#dynamic_district").val()},${$(
      "#dynamic_city option:selected"
    ).text()},${$("#dynamic_state option:selected").text()}`;

    const street = $("#dynamic_street").val();
    const city = $("#dynamic_city option:selected").text();
    const state = $("#dynamic_state option:selected").text();

    if (!street || !city || !state) {
      this.showAddressError('Preencha todos os campos do endereço');
      this.disableSaveButton();
      return;
    }

    const previousLat = lat.value;
    const previousLon = lon.value;

    Rails.ajax({
      url: `/geolocation?address=${encodeURIComponent(addressString)}`,
      type: "get",
      data: "",
      success: (data) => {
        if (data && data.lat && data.lng && data.lat !== 'null' && data.lng !== 'null') {
          lat.value = data.lat;
          lon.value = data.lng;
          lat.dispatchEvent(new Event("change"));
          lon.dispatchEvent(new Event("change"));

          this.removeAddressError();
          this.enableSaveButton();
        } else {
          if (previousLat && previousLon && previousLat !== 'null' && previousLon !== 'null') {
            this.showAddressError('Endereço não encontrado.');
            this.enableSaveButton();
          } else {
            lat.value = '';
            lon.value = '';
            this.showAddressError('Endereço não encontrado. Por favor, verifique e corrija o endereço.');
            this.disableSaveButton();
          }
        }
      },
      error: (data) => {
        if (previousLat && previousLon && previousLat !== 'null' && previousLon !== 'null') {
          this.showAddressError('Erro ao buscar endereço. Mantendo coordenadas anteriores.');
          this.enableSaveButton();
        } else {
          this.showAddressError('Erro ao buscar endereço. Por favor, tente novamente.');
          this.disableSaveButton();
        }
        console.error("Erro na geolocalização:", data);
      },
    });
  }

  showAddressError(message) {
    const errorContainer = document.getElementById('address-error-message');
    if (errorContainer) {
      errorContainer.style.display = 'block';
      errorContainer.className = 'notification is-danger is-light mb-1 p-3 is-size-7';
      errorContainer.innerHTML = `${message}`;
    }
  }

  removeAddressError() {
    const errorContainer = document.getElementById('address-error-message');
    if (errorContainer) {
      errorContainer.style.display = 'none';
      errorContainer.innerHTML = '';
    }
  }

  enableSaveButton() {
    this.saveButtonTarget.disabled = false;
  }

  disableSaveButton() {
    this.saveButtonTarget.disabled = true;
  }
}
